export default function HowItWorks() {
  return (
    <section id="how-it-works" className="py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-4">
            How It <span className="text-emerald-600">Works</span>
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            Our simple 3-step process makes selling your house fast and easy. No complicated paperwork, no lengthy negotiations - just a straightforward path to cash.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 mb-16">
          {/* Step 1 */}
          <div className="relative bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow mt-6 flex flex-col">
            <div className="absolute top-0 left-8 w-12 h-12 flex items-center justify-center bg-emerald-600 text-white rounded-full text-xl font-bold z-10 -translate-y-1/2">
              1
            </div>
            <div className="flex flex-row flex-1 rounded-lg overflow-hidden" style={{minHeight: '220px'}}>
              <div className="flex-1 p-6 pt-10 flex flex-col justify-center">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Submit Your Info</h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  Fill out our simple form with basic details about your property. It takes less than 2 minutes, and there's no obligation.
                </p>
              </div>
              <div className="w-2/5 flex-shrink-0 relative">
                <img
                  src="https://static.readdy.ai/image/a48e56127586ecde9cf388aadcd5ef1b/cc5ca546a11b21391508424073393577.png"
                  alt="Submit your info"
                  className="absolute inset-0 w-full h-full object-contain bg-gray-50"
                />
              </div>
            </div>
          </div>

          {/* Step 2 */}
          <div className="relative bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow mt-6 flex flex-col">
            <div className="absolute top-0 left-8 w-12 h-12 flex items-center justify-center bg-emerald-600 text-white rounded-full text-xl font-bold z-10 -translate-y-1/2">
              2
            </div>
            <div className="flex flex-row flex-1 rounded-lg overflow-hidden" style={{minHeight: '220px'}}>
              <div className="flex-1 p-6 pt-10 flex flex-col justify-center">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Get Your Offer</h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  We'll review your property and present you with a fair, no-obligation cash offer within 24 hours based on current market conditions.
                </p>
              </div>
              <div className="w-2/5 flex-shrink-0 relative">
                <img
                  src="https://static.readdy.ai/image/a48e56127586ecde9cf388aadcd5ef1b/c6f48c1e71755fc97ee57b6197cbe113.png"
                  alt="Get your offer"
                  className="absolute inset-0 w-full h-full object-contain bg-gray-50"
                />
              </div>
            </div>
          </div>

          {/* Step 3 */}
          <div className="relative bg-white rounded-lg shadow-lg hover:shadow-xl transition-shadow mt-6 flex flex-col">
            <div className="absolute top-0 left-8 w-12 h-12 flex items-center justify-center bg-emerald-600 text-white rounded-full text-xl font-bold z-10 -translate-y-1/2">
              3
            </div>
            <div className="flex flex-row flex-1 rounded-lg overflow-hidden" style={{minHeight: '220px'}}>
              <div className="flex-1 p-6 pt-10 flex flex-col justify-center">
                <h3 className="text-xl font-bold text-gray-900 mb-3">Close &amp; Get Cash</h3>
                <p className="text-gray-600 leading-relaxed text-sm">
                  Accept our offer and choose your closing date. We handle all the paperwork and closing costs. Get cash in as little as 7 days.
                </p>
              </div>
              <div className="w-2/5 flex-shrink-0 relative">
                <img
                  src="https://static.readdy.ai/image/a48e56127586ecde9cf388aadcd5ef1b/4a3f8aa83a1073895f5fa49cdf64403f.png"
                  alt="Close and get cash"
                  className="absolute inset-0 w-full h-full object-contain bg-gray-50"
                />
              </div>
            </div>
          </div>
        </div>

        {/* Additional Benefits */}
        <div className="bg-emerald-600 rounded-lg p-10 text-white text-center">
          <h3 className="text-3xl font-bold mb-4">Ready to Sell Your House?</h3>
          <p className="text-xl mb-8 text-emerald-50 max-w-3xl mx-auto">
            Join thousands of satisfied homeowners who have sold their properties quickly and easily with GreenState Investments. Get your free cash offer today!
          </p>
          <div className="flex flex-wrap gap-6 justify-center text-left">
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-2xl"></i>
              <span className="text-sm font-medium">No Realtor Commissions</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-2xl"></i>
              <span className="text-sm font-medium">No Closing Costs</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-2xl"></i>
              <span className="text-sm font-medium">No Repairs Required</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-2xl"></i>
              <span className="text-sm font-medium">No Showings</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-2xl"></i>
              <span className="text-sm font-medium">No Open Houses</span>
            </div>
          </div>
          <div className="flex flex-wrap gap-6 justify-center text-left mt-4">
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-2xl"></i>
              <span className="text-sm font-medium">No Buyer Financing to worry about</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-2xl"></i>
              <span className="text-sm font-medium">No Buyer&apos;s Appraisals to deal with</span>
            </div>
            <div className="flex items-center gap-3">
              <i className="ri-check-double-line text-2xl"></i>
              <span className="text-sm font-medium">No Home Inspections</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
